export default __webpack_public_path__ + "static/media/newsletter2.6290e45a.jpg";